import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-localized-values-dialog',
  templateUrl: './localized-values-dialog.component.html',
})
export class LocalizedValuesDialogComponent {
  @Input() displayLocalizedValues: boolean = false;
  @Input() localizedValues: any[] = [];

  getColumns(data: any[]): string[] {
    if (!data || data.length === 0) return [];
    const firstRow = data[0];
    return Object.keys(firstRow).filter(key => key !== 'id');
  }
} 